// export const API_BASE = `${window.location.protocol}//api.${window.location.hostname}`;
export const API_BASE = `https://api.wedo.party`; //`http://localhost:3001`;
export const LOGIN_PAGE = "auth";